/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPromoDesktopSchema } from '../../repositories/newbuilding-promos/entities/promo/PromoDesktopSchema';
import { IPromoDetails } from '../../types/promos/promoDetails';

// Бэк в promoPopup присылает только недублирующиеся поля.
export const mapPromosDetails = (promo: IPromoDesktopSchema): IPromoDetails => {
  return {
    banks: promo.promoPopup.banks,
    isNewbuildingCountTextLinkable: promo.promoPopup.isNewbuildingCountTextLinkable,
    newbuildingCountText: promo.promoPopup.newbuildingCountText,
    newbuildingIds: promo.newbuildingIds,
    newbuildingLinks: promo.promoPopup.newbuildingLinks,
    promoDescription: promo.promoPopup.promoDescription || null,
    promoName: promo.promoName,
    promoProps: promo.promoProps,
    promoModalProps: promo.promoPopup.promoProps,
    promoType: promo.promoType,
    providerLogo: promo.providerLogo,
    providerName: promo.providerName,
    uniquePromoId: promo.uniquePromoId,
    builderPhone: promo.promoPopup.builderPhone,
    siteBlockId: promo.promoPopup.siteBlockId,
    gaLabel: promo.promoPopup.gaLabel,
    availablePurchaseTerms: promo.promoPopup.availablePurchaseTerms,
    formattedBuilderName: promo.promoPopup.formattedBuilderName,
    fullCreditPriceTitle: promo.promoPopup.fullCreditPriceTitle,
    phoneNewbuildingId: promo.promoPopup.phoneNewbuildingId,
    labels: promo.promoPopup.labels,
    promoLegalTerms: promo.promoPopup.promoLegalTerms,
    isBankMortgage: promo.promoPopup.isBankMortgage,
    button: promo.promoPopup.button,
    creditTerms: promo.promoPopup.creditTerms,
  };
};
